/* Perdays Indonesia theme JS */
(function () {
  "use strict";

  /* ---------- header scroll state ---------- */
  var header = document.querySelector(".pd-header");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("scrolled", window.scrollY > 24);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- mobile menu ---------- */
  var menuBtn = document.querySelector(".pd-menu-btn");
  var mobile = document.querySelector(".pd-mobile");
  if (menuBtn && mobile) {
    menuBtn.addEventListener("click", function () {
      var open = mobile.classList.toggle("open");
      menuBtn.innerHTML = open ? iconSVG("x") : iconSVG("menu");
    });
    mobile.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        mobile.classList.remove("open");
        menuBtn.innerHTML = iconSVG("menu");
      });
    });
  }

  function iconSVG(name) {
    if (name === "x")
      return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="7" x2="20" y2="7"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="17" x2="20" y2="17"/></svg>';
  }

  /* ---------- products explorer ---------- */
  var root = document.querySelector("[data-products]");
  if (root && window.PERDAYS_PRODUCTS) {
    var products = window.PERDAYS_PRODUCTS;
    var state = { product: products[0].id, ing: 0, mode: "komposisi" };

    var selCards = root.querySelectorAll("[data-select]");
    var cardEl = root.querySelector("[data-card]");
    var tabsEl = root.querySelector("[data-tabs]");
    var bodyEl = root.querySelector("[data-explorer-body]");
    var ctaEl = root.querySelector("[data-product-ctas]");

    function getProduct() {
      return products.find(function (p) { return p.id === state.product; });
    }

    function esc(s) {
      return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }

    function renderCard() {
      var p = getProduct();
      var certs = p.certifications.map(function (c) {
        return '<span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1 1 0 0 1 1.52 0C14.5 3.8 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>' + esc(c) + "</span>";
      }).join("");
      var benefits = p.benefits.map(function (b) {
        return '<li><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' + esc(b) + "</li>";
      }).join("");
      cardEl.innerHTML =
        '<div class="pd-card pd-card--' + p.id + '">' +
        '<div class="pd-card__blob1"></div><div class="pd-card__blob2"></div>' +
        '<div class="pd-card__inner">' +
        '<span class="pd-card__hash">' + esc(p.hashtag) + "</span>" +
        '<div class="pd-card__bottle"><img src="' + p.bottle + '" alt="' + esc(p.name) + '"></div>' +
        '<h3 class="pd-card__name">' + esc(p.name) + "</h3>" +
        '<p class="pd-card__aud">' + esc(p.audience) + "</p>" +
        '<p class="pd-card__desc">' + esc(p.description) + "</p>" +
        '<ul class="pd-card__benefits">' + benefits + "</ul>" +
        '<div class="pd-card__meta">' +
        '<div><div class="pd-card__meta-label"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>Cara konsumsi</div><p>' + esc(p.usage) + "</p></div>" +
        '<div><div class="pd-card__meta-label"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>Kemasan</div><p>' + esc(p.supply) + "</p></div>" +
        "</div>" +
        '<div class="pd-card__certs">' + certs + "</div>" +
        "</div></div>";
      ctaEl.innerHTML =
        '<a href="#shop" class="btn btn-dark">Beli ' + esc(p.shortName) + "</a>" +
        '<a href="#quiz" class="btn btn-outline-d">Cocok untuk saya? Cek dulu</a>';
    }

    function renderExplorer() {
      var p = getProduct();
      if (state.mode === "komposisi") {
        var chips = p.ingredients.map(function (ing, i) {
          return '<button class="pd-chip' + (i === state.ing ? " active" : "") + '" data-ing="' + i + '">' + esc(ing.name) + "</button>";
        }).join("");
        var ing = p.ingredients[state.ing];
        bodyEl.innerHTML =
          '<p class="pd-explorer__hint"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/></svg> Klik bahan untuk melihat fungsinya:</p>' +
          '<div class="pd-chips">' + chips + "</div>" +
          '<div class="pd-ing" data-ing-panel>' +
          '<div class="pd-ing__head"><h4 class="pd-ing__name">' + esc(ing.name) + '</h4><span class="pd-ing__dose" style="background:' + p.doseBg + ";color:" + p.doseColor + '">' + esc(ing.dose) + "</span></div>" +
          '<p class="pd-ing__role"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>' + esc(ing.role) + "</p>" +
          '<p class="pd-ing__detail">' + esc(ing.detail) + "</p>" +
          "</div>" +
          '<p class="pd-explorer__foot">* Informasi berdasarkan label produk resmi Perdays (TGA Australia). Suplemen tidak menggantikan pola makan seimbang.</p>';
        bodyEl.querySelectorAll("[data-ing]").forEach(function (btn) {
          btn.addEventListener("click", function () {
            state.ing = parseInt(btn.getAttribute("data-ing"), 10);
            renderExplorer();
          });
        });
      } else {
        var rows = p.compare.map(function (r) {
          return (
            '<div class="pd-row">' +
            '<p class="pd-row__dim">' + esc(r.dimension) + "</p>" +
            '<div class="pd-row__good"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg><p>' + esc(r.perdays) + "</p></div>" +
            '<div class="pd-row__bad"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg><p>' + esc(r.ordinary) + "</p></div>" +
            "</div>"
          );
        }).join("");
        var bars = p.bars.map(function (b) {
          return (
            '<div class="pd-bar-card">' +
            '<p class="pd-bar-card__label">' + esc(b.label) + "</p>" +
            '<div class="pd-bar-row"><div class="pd-bar-row__head"><span style="color:var(--brand-dark)">Perdays</span><span style="color:var(--brand-dark)">' + b.perdays + "</span></div>" +
            '<div class="pd-bar-track"><div class="pd-bar-fill pd-bar-fill--pd-' + p.id + '" data-w="' + b.perdays + '"></div></div></div>' +
            '<div class="pd-bar-row"><div class="pd-bar-row__head"><span style="color:#9ca3af">Bahan biasa</span><span style="color:#9ca3af">' + b.ordinary + "</span></div>" +
            '<div class="pd-bar-track"><div class="pd-bar-fill pd-bar-fill--plain" data-w="' + b.ordinary + '"></div></div></div>' +
            '<p class="pd-bar-card__note">' + esc(b.note) + "</p>" +
            "</div>"
          );
        }).join("");
        bodyEl.innerHTML =
          '<h4 class="pd-compare__title">' + esc(p.compareTitle) + "</h4>" +
          '<p class="pd-compare__sub">Pembanding: <strong>' + esc(p.ordinaryName) + "</strong></p>" +
          rows +
          '<div class="pd-bars">' + bars + "</div>" +
          '<p class="pd-explorer__foot">* Skala ilustratif untuk memudahkan perbandingan karakteristik bentuk bahan.</p>';
        setTimeout(function () {
          bodyEl.querySelectorAll(".pd-bar-fill").forEach(function (el) {
            el.style.width = el.getAttribute("data-w") + "%";
          });
        }, 120);
      }
    }

    selCards.forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.product = btn.getAttribute("data-select");
        state.ing = 0;
        selCards.forEach(function (b) { b.classList.toggle("active", b === btn); });
        renderCard();
        renderExplorer();
      });
    });

    tabsEl.querySelectorAll("[data-mode]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.mode = btn.getAttribute("data-mode");
        tabsEl.querySelectorAll("[data-mode]").forEach(function (b) {
          b.classList.toggle("active", b === btn);
        });
        renderExplorer();
      });
    });

    renderCard();
    renderExplorer();
  }

  /* ---------- quiz ---------- */
  var quizRoot = document.querySelector("[data-quiz]");
  if (quizRoot && window.PERDAYS_QUIZ) {
    var questions = window.PERDAYS_QUIZ.questions;
    var productMap = window.PERDAYS_QUIZ.productMap;
    var step = 0;
    var scores = {};
    var body = quizRoot.querySelector("[data-quiz-body]");
    var fill = quizRoot.querySelector(".pd-quiz__fill");
    var label = quizRoot.querySelector("[data-quiz-step-label]");

    function escQ(s) {
      return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    function renderStep() {
      var q = questions[step];
      var opts = q.options.map(function (o, i) {
        return (
          '<button class="pd-opt" data-opt="' + i + '">' +
          "<span><span class=\"pd-opt__label\">" + escQ(o.label) + "</span>" +
          (o.hint ? '<span class="pd-opt__hint" style="display:block">' + escQ(o.hint) + "</span>" : "") +
          "</span>" +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>' +
          "</button>"
        );
      }).join("");
      body.innerHTML =
        '<div class="pd-quiz__q-head"><div class="pd-quiz__q-num">' + (step + 1) + '</div><h3 class="pd-quiz__q-title">' + escQ(q.title) + "</h3></div>" + opts;
      fill.style.width = Math.round((step / questions.length) * 100) + "%";
      label.textContent = "Langkah " + (step + 1) + " dari " + questions.length;
      body.querySelectorAll("[data-opt]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var opt = q.options[parseInt(btn.getAttribute("data-opt"), 10)];
          Object.keys(opt.scores).forEach(function (k) {
            scores[k] = (scores[k] || 0) + opt.scores[k];
          });
          if (step + 1 >= questions.length) renderResult();
          else { step++; renderStep(); }
        });
      });
    }

    function renderResult() {
      var sorted = Object.keys(scores).map(function (k) { return [k, scores[k]]; });
      sorted.sort(function (a, b) { return b[1] - a[1]; });
      var winners;
      if (sorted.length === 0) winners = ["iron"];
      else {
        var top = sorted[0][1];
        winners = sorted.filter(function (s) { return s[1] >= top - 1; }).slice(0, 2).map(function (s) { return s[0]; });
      }
      var cards = winners.map(function (id, idx) {
        var p = productMap[id];
        var benefits = p.benefits.slice(0, 2).map(function (b) {
          return '<li><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' + escQ(b) + "</li>";
        }).join("");
        return (
          '<div class="pd-result-card' + (idx === 0 ? " primary" : "") + '">' +
          '<div class="pd-result-card__num" style="background:linear-gradient(135deg,' + p.gradFrom + "," + p.gradTo + ')">' + (idx + 1) + "</div>" +
          "<div style=\"flex:1\">" +
          '<p class="pd-result-card__name">' + escQ(p.name) + "</p>" +
          '<div class="pd-result-card__badges"><span style="background:' + p.badgeBg + ";color:" + p.badgeColor + '">' + escQ(p.hashtag) + "</span>" +
          (idx === 0 ? '<span style="background:var(--brand-dark);color:#fff">PALING SESUAI</span>' : "") + "</div>" +
          '<p style="font-size:.875rem;color:#4b5563">' + escQ(p.tagline) + " — " + escQ(p.audience) + "</p>" +
          "<ul>" + benefits + "</ul>" +
          "</div></div>"
        );
      }).join("");
      var primary = productMap[winners[0]];
      body.innerHTML =
        '<div class="pd-result__head">' +
        '<div class="pd-result__icon"><svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="8" height="4" x="8" y="2" rx="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="m9 14 2 2 4-4"/></svg></div>' +
        '<h3 class="h-section" style="font-size:1.5rem;margin-bottom:.5rem">Rekomendasi untuk Anda</h3>' +
        '<p style="color:#4b5563">Berdasarkan jawaban Anda, formula paling sesuai adalah:</p></div>' +
        cards +
        '<div class="pd-result__ctas">' +
        '<a href="#products" class="btn btn-dark">Lihat Detail ' + escQ(primary.shortName) + "</a>" +
        '<button class="btn btn-outline-d" data-quiz-restart><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M3 21v-5h5"/></svg> Ulangi</button>' +
        "</div>";
      fill.style.width = "100%";
      label.textContent = "Selesai";
      body.querySelector("[data-quiz-restart]").addEventListener("click", function () {
        step = 0; scores = {}; renderStep();
      });
    }

    renderStep();
  }

  /* ---------- expert bio expand ---------- */
  document.querySelectorAll("[data-expert-more]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var bio = btn.closest(".pd-expert__body").querySelector(".pd-expert__bio");
      var open = bio.classList.toggle("clamped");
      btn.classList.toggle("open", !open);
      btn.querySelector("span").textContent = open ? "Baca profil" : "Tutup";
    });
  });
})();
